export default __webpack_public_path__ + "static/media/GCC_resident_ID.f634ac45.svg";